import { useLocation, useNavigate } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PageHeader } from '@/components/dashboard-ui'
import ChatPage from './ChatPage'
import ConversationsPage from './ConversationsPage'

/**
 * Unified "Live Chats" hub. Active sessions + historical conversations share
 * one sidebar slot; the URL determines which tab is pre-selected so deep
 * links from emails / alerts still land where they used to.
 *
 * Routes:
 *   /chats          → Active tab (live sessions via ChatPage)
 *   /conversations  → History tab (past conversations via ConversationsPage)
 *
 * The hub owns the PageHeader so child pages (ChatPage / ConversationsPage)
 * don't double up on titles when rendered nested here.
 */
export default function ChatHubPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const tab: 'active' | 'history' = location.pathname.startsWith('/conversations') ? 'history' : 'active'

  return (
    <div className="h-full flex flex-col">
      <PageHeader
        eyebrow="Activity"
        title="Live Chats"
        subtitle="Active visitor sessions and the archive of past conversations."
        size="tight"
        flat
        actions={
          <Tabs
            value={tab}
            onValueChange={(v) => navigate(v === 'history' ? '/conversations' : '/chats')}
          >
            <TabsList>
              <TabsTrigger value="active">Active</TabsTrigger>
              <TabsTrigger value="history">History</TabsTrigger>
            </TabsList>
          </Tabs>
        }
      />
      <div className="flex-1 min-h-0">
        {tab === 'active' ? <ChatPage embedded /> : <ConversationsPage embedded />}
      </div>
    </div>
  )
}
